import React, { useState } from "react";
import { debug } from "../../utils";
import { connect } from "react-redux";
import EditDeviceModal from "../edit-device-modal/EditDeviceModal";
import { createInstantReport, downloadInstantReport, deleteInstantReport } from "../../reports/reportService";
import { showDangerToast, showSuccessToast } from "../../validation/ToastContainer";
import { Download } from "lucide-react";


function DeviceDetailsHeader({ hostName, mngtIpAddress, deviceId }) {

    const [showModal, setShowModal] = useState(false);
    //const [showReportModal, setShowReportModal] = useState(false);

    const onModifySettingsClick = () => {
        setShowModal(true);
    }


    const onExportReportClick = async () => {
        const fileName = 'ns_' + Date.now().toString();
        // dateFrom: new Date('2020-01-01T00:00:00Z'),
        const reportDto = {
            hostName,
            description: '',
            type: 'DETAILED',
            deviceId,
            range: 'LAST_MONTH',
            dateFrom: new Date(),
            dateTo: new Date(),
            filename: fileName,
            mimeType: 'PDF' //todo change
        }

        // createInstantReport(reportDto).then(response => {
        //     if(response.ok) {
        //         downloadInstantReport(fileName).then(response => {
        //             if(response.ok) {
        //                 deleteInstantReport(fileName)
        //                 showSuccessToast(`${hostName} report created Successfully!`, "Create Device Report");
        //             }
        //         });             
        //     }
        //     else {
        //         const json = response.json();
        //         showDangerToast(`Something went wrong: ${json.message}`, `Create report: ${response.status} `)
        //     }
        // })

        createInstantReport(reportDto).then(response => {
            if (response.ok) {
                downloadInstantReport(fileName);
                deleteInstantReport(fileName)
                showSuccessToast(`${hostName} report created`, "Create Device Report");

            }
            else {
                const json = response.json();
                showDangerToast(`Something went wrong: ${json.message}`, `Create report: ${response.status} `)
            }
        })
    }


    // const handleCreate = () => {
    //     showInfoToast("Report generation has started", "Create report", '', true);
    //     setShowReportModal(false);
    // }
    //{showModal && <CreateReportModal handleClose={() => showReportModal(false)} handleCreate={handleCreate} />}

    return (
        <>
            <EditDeviceModal showModal={showModal} setShowModal={setShowModal} deviceId={deviceId} />

            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="oct_detail-header-v2">

                            <div className="oct_card-title">
                                <h2>{hostName}</h2>
                                <div className="oct_card-sub-title">{mngtIpAddress}</div>
                            </div>

                            <div className="oct_card-tools mt-2">
                                {/* <a className="oct_card-btn btn oct_btn-secondary" onClick={() => notImplemented()}>
                                    Policy Details
                                </a>
                                <a className="oct_card-btn btn oct_btn-secondary" onClick={() => notImplemented()}>
                                    Refresh Configuration
                                </a> */}
                                <div className="oct_btn-export-v2 mr-2"
                                    onClick={() => onExportReportClick()}>
                                                                <Download className="oct_icon" />
                                        
                                    Export Report
                                </div>
                                <div className="oct_btn-export-v2"
                                    onClick={() => onModifySettingsClick()}>
                                    Modify Settings
                                </div>
                                {/* <a className="oct_card-btn btn oct_btn-secondary" onClick={() => notImplemented()}>
                                    MSB Settings
                                </a>
                                <a className="oct_card-btn btn oct_btn-secondary" onClick={() => notImplemented()}>
                                    Compliance
                                </a> */}
                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </>
    )
}

function mapStateToProps(state) {
    debug("DeviceDetailsHeader mapStateToProps", state);
    const device = state.deviceDetailsPage.device;
    return {
        hostName: device ? device.hostName : '',
        mngtIpAddress: device ? device.mngtIpAddress : '',
    };
}

export default connect(mapStateToProps)(DeviceDetailsHeader);
